/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { omit } from 'lodash';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import ModalForm from 'shared/ui/components/form-components/ModalForm.vue';
import ParticipantAvailability from 'ui/components/meetings/meeting-requests/ParticipantAvailability.vue';

const __vue_script__ = {
    name: 'AttendeePicker',

    components: { BaseSelect, GenericDocExternalPicker, ParticipantAvailability },

    extends: BaseControl,

    props: {
        event: {
            required: true,
            type: Object
        },

        value: {
            type: [Object, Array],
            default: null
        },

        options: {
            type: Object,
            default: () => ({})
        },

        model: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            attrs: {},
            acceptanceOptions: [
                { value: 'yes', label: this.$t('meetings.details.statuses.accepted') },
                { value: 'no', label: this.$t('meetings.details.statuses.declined') },
                { value: 'pending', label: this.$t('meetings.details.statuses.pending') },
            ],
            loading: false,
            attendees_script: 'meetings/get-attendees-for-picker',
            exclusions: [],
        };
    },

    computed: {
        innerValue: {
            get: function() {
                const ensureValues = doc => {
                    if (doc && !doc.label && doc.fname && doc.lname) {
                        doc.label = [doc.fname, doc.lname].join(' ');
                    }
                    return doc;
                };
                return Array.isArray(this.value)
                    ? this.value.map(ensureValues)
                    : ensureValues(this.value);
            },

            set: function(value) {
                this.$emit('input', value);
            }
        },
        showAvailability() {
            return this.model.fp_type === 'meeting-request' && this.name === 'participants';
        },
        excludeProspects() {
            return this.name === 'organizer' || this.name === 'representative';
        },
    },

    watch: {
        $attrs: {
            immediate: true,
            handler() {
                this.attrs = omit({ ...this.$options.propsData, ...this.$attrs }, 'model', 'options');
            }
        },

        model: {
            immediate: true,
            deep: true,
            handler(model) {
                const getExclusions = model => {
                    if (this.options?.exclude && model.hasOwnProperty(this.options.exclude)) {
                        const modelField = model[this.options.exclude];

                        if (Array.isArray(modelField)) {
                            return modelField.map(person => person.fp_ext_id);
                        } else if (modelField?.fp_ext_id) {
                            return [modelField.fp_ext_id];
                        }
                    }
                    return [];
                };
                this.exclusions = getExclusions(model);
            }
        },

        value: {
            immediate: true,
            handler() {
                this.loadStatus();
            }
        },
    },

    methods: {
        async loadStatus() {
            if (this.options.hidePaxStatus) {
                return;
            }

            if (!this.options.status_script) {
                return;
            }

            try {
                if (this.loading || !this.model.fp_owner) return;
                this.loading = true;
                const params = {
                    id: this.model.fp_owner,
                    meeting_id: this.model._id
                };

                // Cache of 3 seconds to avoid multiple requests close to eachother
                const data = await this.$services.appScripts.callAppScriptCached(this.event._id, this.options.status_script, params, true, 3000);
                this.setStatuses(data);
            } catch (error) {
                console.error('[AttendeePicker] Error while loading status:', error);
            } finally {
                this.loading = false;
            }
        },

        setStatuses(statuses) {
            if (this.options.multiple) {
                for (const person of this.innerValue) {
                    const att = statuses?.find(a => a.fp_owner === person._id);
                    this.setPersonAttendance(person, att?.attendance);
                }
            } else {
                this.setPersonAttendance(this.innerValue, statuses?.attendance);
            }
        },

        ensureDefaultStatuses(input) {
            if (Array.isArray(input)) {
                input.forEach(person => this.setPersonAttendance(person));
            } else {
                this.setPersonAttendance(input);
            }
        },

        setPersonAttendance(person, attendance) {
            this.setPersonStatus(person, 'attendance', attendance || 'pending');
        },

        setPersonStatus(person, statusName, status) {
            if (!person || person[statusName] === status) {
                return;
            }

            this.$set(person, statusName, status);
        },

        getActionController(action) {
            return this.$services.blueprint.getControllerByName(action.moduleName || 'meetings', action.controllerKey);
        },

        isActionVisible(action) {
            const controller = this.getActionController(action);
            if (!controller) {
                return false;
            }

            return controller.permission ? this.$services.user.hasPermission(controller.permission) : true;
        },

        async performAction(action) {
            const controller = this.getActionController(action);
            const fpType = controller.routeOptions.modelFpType;
            const metadata = await this.$services.metadata.getMetadataForType(this.event._id, fpType);
            const type = this.$utils.strings.humanizeType(metadata, fpType);

            this.$modal.show(ModalForm, {
                title: this.$t('generic_form.external_picker.new_external', [type.toLocaleLowerCase()]),
                event: this.event,
                model: {},
                fpType,
                onSave: async res => {
                    await this.addProspectToPicker(res._id);
                }
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        onEditProspect(prospectId) {
            this.$modal.show(ModalForm, {
                title: this.$t('generic_form.external_picker.external_participant'),
                event: this.event,
                docId: prospectId,
                fpType: 'prospect',
                onSave: async res => {
                    this.updateProspectInPicker(res._id);
                }
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        async addProspectToPicker(prospectId) {
            try {
                const prospects = await this.$services.appScripts.callAppScript(this.event._id, this.attendees_script, { ids: [prospectId] });
                const newProspect = { ...prospects[0], attendance: 'pending' };
                this.innerValue = [...this.innerValue, newProspect];
                this.loadStatus();
            } catch (error) {
                console.error('[AttendeePicker] Error while saving prospect:', error);
            }
        },

        async updateProspectInPicker(prospectId) {
            try {
                const [updatedProspect] = await this.$services.appScripts.callAppScript(this.event._id, this.attendees_script, { ids: [prospectId] });
                const index = this.innerValue.findIndex(pax => pax._id === updatedProspect._id);

                if (index !== -1) {
                    const updatedInnerValue = [...this.innerValue];
                    const currentPax = updatedInnerValue[index];
                    for (const key in updatedProspect) {
                        if (currentPax[key] !== updatedProspect[key]) {
                            this.$set(currentPax, key, updatedProspect[key]);
                        }
                    }
                    this.innerValue = updatedInnerValue;
                }
            } catch (error) {
                console.error('[AttendeePicker] Error while saving prospect:', error);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attendee-picker form-group",class:{ 'grouped-controls': !_vm.options.multiple }},[_c('generic-doc-external-picker',_vm._b({class:{ 'form-groups': !_vm.options.multiple },attrs:{"emit-key":"_id","fp-type":"person","appscript":_vm.attendees_script,"appscript-extra-params":{ excludeProspects: _vm.excludeProspects },"value-key":"ids","name":_vm.name,"event-id":_vm.event._id,"placeholder":_vm.placeholder,"emit-objects":true,"multiple":_vm.options.multiple,"sortable":false,"exclusions":_vm.exclusions,"errors":_vm.errors},on:{"input":_vm.ensureDefaultStatuses},scopedSlots:_vm._u([(_vm.options.actions)?{key:"custom-actions",fn:function(ref){return [_vm._l((_vm.options.actions),function(action){return [(_vm.isActionVisible(action))?[(action.type === 'anchor')?_c('a',{staticClass:"has-action",attrs:{"href":"#","disabled":_vm.disabled},on:{"click":function($event){!_vm.disabled && _vm.performAction(action)}}},[_vm._v(_vm._s(_vm.$t(action.label)))]):_c('button',{staticClass:"btn btn-mini",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){!_vm.disabled && _vm.performAction(action)}}},[_vm._v(_vm._s(_vm.$t(action.label)))])]:_vm._e()]})]}}:null,{key:"option",fn:function(ref){
var option = ref.option;
return [(option.fp_type === 'prospect')?_c('span',{staticClass:"subtitle ext"},[_vm._v(_vm._s(_vm.$t('generic_form.external_picker.external_participant')))]):_vm._e()]}},{key:"document-item-subtitle",fn:function(ref){
var doc = ref.doc;
return [(doc.fp_type === 'prospect')?_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('generic_form.external_picker.external_participant')))]):_vm._e(),(doc.missing_email)?_c('div',{staticClass:"subtitle warning"},[_vm._v(_vm._s(_vm.$t('meetings.form.hints.missing_propsect_email')))]):_vm._e()]}},{key:"document",fn:function(ref){
var doc = ref.doc;
return [_c('div',{staticClass:"doc-extras"},[(!_vm.options.hidePaxStatus)?_c('base-select',{attrs:{"emit-option-value-only":true,"name":(_vm.name + "-acceptance"),"label":_vm.options.acceptance_label,"options":_vm.acceptanceOptions,"disabled":_vm.disabled},model:{value:(doc.attendance),callback:function ($$v) {_vm.$set(doc, "attendance", $$v)},expression:"doc.attendance"}}):_vm._e(),(_vm.showAvailability)?_c('participant-availability',{attrs:{"doc":doc,"event":_vm.event,"parentModel":_vm.model}}):_vm._e()],1)]}},{key:"doc-actions",fn:function(ref){
var doc = ref.doc;
return [(doc.fp_type === 'prospect')?_c('a',{staticClass:"edit has-action",attrs:{"href":"#","aria-label":_vm.$t('meetings.requests.participants.availability.send_email_aria_label')},on:{"click":function($event){return _vm.onEditProspect(doc._id)}}},[_c('i',{staticClass:"ic-edit"})]):_vm._e()]}}],null,true),model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'generic-doc-external-picker',_vm.attrs,false))],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AttendeePicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__